import { MatInputModule } from '@angular/material/input';
import { FormlyModule } from '@ngx-formly/core';
import { MatOptionModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { MatSelectModule } from '@angular/material/select';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';

/*<div *ngFor="let step of steps; let index = index; let last = last">
<formly-field [field]="step"></formly-field>
</div>,
*/
@Component({
    template:`<form [formGroup]="formModel">
<formly-form [model]="model" [fields]="[fields]" [options]="options" [form]="formModel"></formly-form>
</form>`,
    standalone: true,
    imports: [
        MatButtonModule,
        ReactiveFormsModule,
        FormlyMaterialModule,
        MatOptionModule,
        FormlyModule,
        MatSelectModule,
        MatInputModule,
        MatSidenavModule,
        MatIconModule,
        MatProgressBarModule,
        MatTabsModule,
        MatStepperModule,
        ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RiepilogoType extends FieldType implements OnInit {

    steps: any[];
    editMode: boolean = false;

    fields: FormlyFieldConfig = {
        fieldGroup: []
    }


    formModel = new FormGroup({});

    ngOnInit(): void {
        this.fields.fieldGroup = this.props.fields.filter((step:any)=>!step.props.exclude)
        this.editMode = false
    }


}
